module.exports = __webpack_public_path__ + "img/pod-number.9b41d048.png";